import React, { Component } from 'react'
import {reduxForm, Field} from 'redux-form'
import { Row, Col } from 'react-bootstrap'
import Button from '../comun/button/Button'
import InputCheckBox from '../comun/form/InputCheckBox'
import { AddCircleOutline, Delete } from '@material-ui/icons'
import {permisos as permisosConstant} from '../../constants/permisos'

class FiltrosTrazabilidadMaterial extends Component {
  constructor () {
    super()
    this.state = {
      imputSelected: false,
    }
    this.deleteSeleccionTrazabilidadMaterial = this.deleteSeleccionTrazabilidadMaterial.bind(this)
  }

  intercambiarCheck = (value) => {
    this.setState({ imputSelected: value })
    if (value === true) {
      this.props.actions.seleccionarTodosTrazabilidadMaterial()
    } else {
      this.props.actions.deSeleccionarTodosTrazabilidadMaterial()
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.listadoTrazabilidadMaterialTable && Object.keys(this.props.listadoTrazabilidadMaterialTable).length > 0) {
      if (this.props.listadoTrazabilidadMaterialTable !== prevProps.listadoTrazabilidadMaterialTable) {
        let contActivos = 0
        if (this.props.listadoTrazabilidadMaterialTable.values) {
          Object.values(this.props.listadoTrazabilidadMaterialTable.values).forEach((value) => {
            if (value === true) {
              contActivos++
            }
          })
          if (contActivos === 0) {
            this.props.change('seleccionar-todos-modal-trazabilidad', false)
            this.setState({ imputSelected: false })
            this.props.actions.deSeleccionarTodosTrazabilidadMaterial()
          }
        }
      }
    }
  }

  deleteSeleccionTrazabilidadMaterial(){
    const itemsSeleccion = this.props.lotesEscandallo.map((row) => {
      return this.props[this.props.idForm].values['check' + this.props.idForm + row[this.props.idElemento]] === true && (
        {
          'check': this.props[this.props.idForm].values['check' + this.props.idForm + row[this.props.idElemento]],
          [this.props.idElemento]: row[this.props.idElemento]
        }
      )
    })
    let list = itemsSeleccion.filter(function (item) {
      return item.check === true;
    });
    this.props.actions.deleteSeleccionTrazabilidadMaterial(list)
  }

  render () {
  const {
    t,
    auth: { permisos },
    actions: {openModalMaterialDisponible}
  } = this.props
  const tKey = 'ANALISIS_EXTRACCIONES.TRAZABILIDAD_MATERIAL.'

  return (
      <div>
        <Row className="acciones-tabla-filtros">
          <Col sm={6}>
            <div className="buttons-flex">
              {(this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.ANALISIS] > 1) && [
                <div className="custom-check-w" key="custom-check-w">
                  <Field
                    id="seleccionar-todos-modal-trazabilidad"
                    name="seleccionar-todos-modal-trazabilidad"
                    colSm={12}
                    inline
                    component={InputCheckBox}
                    onInputChange={(value) => this.intercambiarCheck(value)}
                  />
                </div>,
                <div id="block-options1" key="block-options1" className={this.state.imputSelected === true ? 'button-group buttons-min block-options' : 'button-group buttons-min block-options oculta-action'}>
                  <button type="button" className="btn btn-icono" onClick={(e) => this.deleteSeleccionTrazabilidadMaterial()}>
                    <Delete /> {t('TITULOS_BOTONES.ELIMINAR')}
                  </button>
                  <div className="barra-buttons-min"></div>
                </div>
              ]}
              <div className="button-group buttons-min">
                <Button
                  type="button"
                  className={"btn btn-primary nuevo" + ((this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.ANALISIS] < 2) ? ' disabled' : '')}
                  onClick={(this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.ANALISIS] > 1) ? openModalMaterialDisponible : undefined}
                >
                  <AddCircleOutline /> {t('TITULOS_BOTONES.NUEVO')}
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}

export default (reduxForm({
  form: 'FiltrosTrazabilidadMaterial',
})(FiltrosTrazabilidadMaterial))
